@if (isHamburgerVisible()) {
    <div>
        <span class="nav-plan">
            <a
                (click)="hideHamburger()"
                class="closeBtn">
                <i class="nlrp-icon nlrp-icon-close"></i>
            </a>
        </span>
        <!-- Plan Actions buttons -->
        @if (displayPlanActions()) {
            <ul class="top-nav">
                <li>Plan Actions</li>
                <ul class="sub-nav">
                    <li>
                        <!-- Save Plan -->
                        @if (displaySaveAction()) {
                            <a
                                id="savePlanBtn"
                                (click)="save()"
                                title="Save plan (all plan data will be saved)">
                                Save Plan
                            </a>
                        }
                    </li>
                    @if (isDisplayCreateFromCad()) {
                        <li>
                            <!-- Create PDF from CAD -->
                            <a
                                id="createFromCadBtn"
                                (click)="createFromCad()"
                                title="Create PDF from CAD">
                                Create PDF from CAD
                            </a>
                        </li>
                    }
                    @if (isDisplayCreateFromPortal()) {
                        <li>
                            <!-- Create PDF in Portal -->
                            <a
                                id="createInPortalBtn"
                                (click)="createFromPortal()"
                                title="Create PDF in Portal">
                                Create PDF in Portal
                            </a>
                        </li>
                    }
                    @if (isDisplayCreateDigitalPlan()) {
                        <li>
                            <a
                                id="createDigitalPlanBtn"
                                (click)="createDigitalPlan()"
                                title="Create Digital Plan">
                                Create Digital Plan
                            </a>
                        </li>
                    }
                </ul>
            </ul>
        }
        @if (displayPlanActions()) {
            <ul class="top-nav">
                <li>Plan Status</li>
                <ul class="sub-nav">
                    <!-- In Design -->
                    @if (showInDesign()) {
                        <ul class="sub-nav">
                            <li>
                                <a
                                    id="moveToInDesignBtn"
                                    (click)="triggerInDesign()"
                                    title="Move plan to a status of 'In Design' (plan can be edited if role allows)">
                                    In Design
                                </a>
                            </li>
                        </ul>
                    }
                    <!-- Ready for QA -->
                    @if (showReadyForQA()) {
                        <ul class="sub-nav">
                            <li>
                                <a
                                    id="moveToReadyForQaBtn"
                                    (click)="triggerRequestForQA()"
                                    title="Move plan to a status of 'Ready for QA' (plan can be QA'd)">
                                    Ready for QA
                                </a>
                            </li>
                        </ul>
                    }
                    <!-- Ready for Certification -->
                    @if (showReadyForCertification()) {
                        <ul class="sub-nav">
                            <li>
                                <a
                                    id="moveToReadyForCertificationBtn"
                                    (click)="triggerRequestForCertification()"
                                    title="Move plan to a status of 'Ready for Certification' (plan can be certified)">
                                    Ready for Certification
                                </a>
                            </li>
                        </ul>
                    }
                    <!-- Ready for Lodgement -->
                    @if (showReadyForLodgement()) {
                        <ul class="sub-nav">
                            <li>
                                <a
                                    id="moveToReadyForLodgementBtn"
                                    (click)="triggerCertification()"
                                    title="Move plan to a status of 'Ready for Lodgement' (plan can be lodged)">
                                    Ready for Lodgement
                                </a>
                            </li>
                        </ul>
                    }
                    <!-- Lodge Plan -->
                    @if (showLodgePlan()) {
                        <ul class="sub-nav">
                            <li>
                                <a
                                    id="lodgePlanBtn"
                                    (click)="triggerLodge()"
                                    title="Lodge plan with Landgate">
                                    Lodge Plan
                                </a>
                            </li>
                        </ul>
                    }
                    @if (showNoAvailableProcesses()) {
                        <ul class="top-nav">
                            <li>
                                <i>No available processes</i>
                            </li>
                        </ul>
                    }
                </ul>
            </ul>
        }
        @if (showPrintPdfLink()) {
            <ul class="top-nav">
                <li>Print</li>
                <ul class="sub-nav">
                    <div>
                        <li>
                            <a
                                id="printToPdfBtn"
                                (click)="openPrintPdfModal()"
                                title="Print plan to PDF">
                                Print to PDF
                            </a>
                        </li>
                    </div>
                </ul>
            </ul>
        }
        @if (showPrintDigitalPlanPdfLink()) {
            <ul class="top-nav">
                <li>Print</li>
                <ul class="sub-nav">
                    <div>
                        <li>
                            <a
                                id="printDigitalPlanPdfBtn"
                                (click)="printDigitalPlanPdf()"
                                title="Print plan to PDF">
                                Print to PDF
                            </a>
                        </li>
                    </div>
                </ul>
            </ul>
        }
    </div>
}

@if (isAssignPlanModalOpen) {
    <nlr-assign-plan
        (assignPlanEvent)="assignPlan($event)"
        (modalCloseEvent)="closeAssignPlanModal()"></nlr-assign-plan>
}
